import React, { FC, useEffect } from 'react';
import { create } from 'zustand';

export interface GaugeStore {
  activeItem: number | string | null;
  feedback?: string;
  select(id: number | string, feedback?: string): void;
  arrowRotate: number;
  setArrowRotate(angle: number): void;
  mediaUrl?: string;
  setMediaUrl(mediaUrl: string): void;
  subtitlesUrl?: string;
  setSubtitlesUrl(mediaUrl: string): void;
}

const _useGaugeStore = create<GaugeStore>(set => ({
  arrowRotate: 0,
  activeItem: null,
  mediaUrl: '',
  select: (id, feedback) => set({ activeItem: id, feedback: feedback }),
  setArrowRotate: angle => set({ arrowRotate: angle }),
  setMediaUrl: mediaUrl => set({ mediaUrl }),
  subtitlesUrl: '',
  setSubtitlesUrl: subtitlesUrl => set({ subtitlesUrl })
}));

export const GaugeProvider: FC = ({ children }) => {
  useEffect(() => {
    useGaugeStore.setState({arrowRotate: 0, activeItem: null, mediaUrl: '', subtitlesUrl: ''});
  }, []);

  return <>{children}</>
};

export const useGaugeStore = _useGaugeStore;
